<template>
  <base-dialog class="batch-update-dialog" width="485px" :visible.sync="visible" show-close>
    <template v-slot:header>
      批量编辑
    </template>
    <el-form label-width="85px">
      <el-form-item label="字段">
        <el-select v-model="property" @change="change">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="字段内容">
        <div v-if="property !== 'priority'">
          <el-radio v-model="clear" :label="false">修改为新值</el-radio>
          <el-radio v-model="clear" :label="true">清空内容</el-radio>
        </div>
        <div v-if="!clear">
          <el-date-picker
            v-if="property === 'startAt' || property === 'dueDate'"
            v-model="value"
            type="date"
            placeholder="请选择"
            default-time="00:00:00"
            value-format="yyyy-MM-dd HH:mm:ss"
            :picker-options="{ disabledDate: notInDuration }"
          ></el-date-picker>
          <rich-input v-model="value" v-else-if="property === 'description'"></rich-input>
        </div>
        <el-select v-if="property === 'priority'" v-model="value" placeholder="请选择">
          <el-option
            v-for="(level, index) in priorityLevel"
            :key="index"
            :label="level.label"
            :value="level.value"
          ></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import RichInput from "@/components/FormControl/RichInput"
import { priorityLevel } from "~/data/project"
import dj from "dayjs"
import { getProject } from "@/api/project/project"

export default {
  name: "BatchUpdateDialog",
  components: { RichInput, BaseButton, BaseDialog },
  props: {
    projectId: String
  },
  data() {
    return {
      visible: false,
      options: [
        {
          value: "startAt",
          label: "开始时间"
        },
        {
          value: "dueDate",
          label: "截止时间"
        },
        {
          value: "priority",
          label: "任务优先级"
        },
        {
          value: "description",
          label: "任务备注"
        }
      ],
      property: null,
      clear: false,
      value: "",
      priorityLevel,
      projectInfo: {}
    }
  },
  methods: {
    open() {
      this.property = "startAt"
      this.visible = true
      this.projectInfo = getProject(this.projectId).then(res => {
        this.projectInfo = res
      })
    },
    change() {
      this.value = ""
    },
    notInDuration(date) {
      let earliestTime = this.projectInfo.startPeriod
      let latestTime = this.projectInfo.endPeriod
      return !dj(date).isBetween(earliestTime, latestTime, null, "[]")
    },
    submit() {
      if (this.clear && this.property !== "priority") {
        this.value = ""
      } else {
        if (!this.value) {
          this.$message.error("内容未填写！")
          return
        }
      }
      this.$emit("select", { property: this.property, value: this.value })
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.batch-update-dialog {
  .el-form {
    margin-top: 18px;
  }
}
</style>
